import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseModalManagement } from 'app/components/common/BaseModalManagement'
import BaseText from 'app/components/common/BaseText'
import { useModalHook } from './hook'
import { IPropsReTryVoucher } from './type'
import { BaseRow } from 'app/components/common/BaseRow'

export const ReTryVoucher = (props: IPropsReTryVoucher) => {
  const { visible, isLoading, showModal, handleCancel, handleSubmit, t } =
    useModalHook(props)

  return (
    <BaseModalManagement
      isLoading={isLoading}
      typeButtonOpen="delete"
      titleKeyI18n={R.strings.retry_generate_voucher}
      showModal={showModal}
      handleCancel={handleCancel}
      textOpenModalI18n={R.strings.retry_generate_voucher}
      confirmKeyI18n={R.strings.retry_generate_voucher}
      handleSubmit={handleSubmit}
      visible={visible}
      widthModal={500}
      descriptionDelete={
        <BaseRow gutter={8} align={'middle'} justify={'center'}>
          <BaseCol>
            <BaseText
              children={t(R.strings.are_you_want_retry_generate_voucher)}
              fontSize="xs"
            />
          </BaseCol>
        </BaseRow>
      }
    />
  )
}
